<div class="health-status-section">
  <span class="health-status-section__header" [ngClass]="healthCategoryCss">
    {{ this.deviceHealthStatus | deviceHealthCategoryLocalizePipe }}
  </span>
  <span class="health-status-section__tooltip"> {{ this.deviceHealthStatus | deviceHealthIssueTooltip: deviceType }} </span>
</div>
